import * as braintree from 'braintree-web';

let paypalInstancePromise: Promise<any> | null = null;

export const initializePaypalSDK = async (
  clientToken: string,
): Promise<any> => {
  if (!paypalInstancePromise) {
    paypalInstancePromise = (async () => {
      if (!clientToken) {
        throw new Error('Client token is required');
      }

      const client = await braintree.client.create({
        authorization: clientToken,
      });

      const paypalCheckout = await braintree.paypalCheckout.create({
        client,
      });

      await paypalCheckout.loadPayPalSDK({ vault: true });
      return paypalCheckout;
    })();
  }

  return paypalInstancePromise;
};
